<template>
    <div>
        <rkm-modal
            extra-large
            ref="RkmModal"
            title="CBO com permissão de visualização"
        >
            <rkm-form
                ref="RkmForm"
                show-legend
            >
                <rkm-row>
                    <rkm-col>
                        <rkm-form-input-autocomplete
                            :repository="repositories.ocupacao"
                            :search-fields="searchFields"
                            :text-field="(item) => item.codigo ? `${item.codigo} - ${item.nome}` : null"
                            :validations="validations.ocupacao"
                            label="CBO"
                            v-model="model.ocupacao"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-button
                            :label="false"
                            @click="include"
                            color="primary"
                        >
                            Incluir
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="clean"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>

            <rkm-row>
                <rkm-col>
                    <rkm-table
                        :fields="fields"
                        :items="model.ocupacoes"
                    >
                        <template v-slot:cell(ocupacao)="{item}">
                            {{item.codigo}} - {{item.nome}}
                        </template>

                        <template v-slot:cell(actions)="row">
                            <rkm-button
                                @click="destroy(row.index)"
                                color="danger"
                                small
                                title="Excluir"
                            >
                                <rkm-icon icon="trash" />
                            </rkm-button>
                        </template>
                    </rkm-table>
                </rkm-col>
            </rkm-row>

            <template v-slot:footer="{cancel}">
                <rkm-button @click="cancel">
                    Cancelar
                </rkm-button>

                <rkm-button
                    @click="save"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>
        </rkm-modal>
    </div>
</template>

<script>
// Mixins.
import {error, object, repository, stringCase} from '@/mixins'

export default {
    computed: {
        searchFields() {
            return [
                {key: 'ocupacao.codigo', searchable: true},
                {key: 'ocupacao.nome', searchable: true},
            ]
        },
        validations() {
            return {
                ocupacao: {required: true},
            }
        },
    },
    created() {
        this.repositories = {
            ocupacao: this.getConectaSusRepository('sigtap.ocupacao'),
        }
    },
    data: () => ({
        fields: [
            {key: 'ocupacao', label: 'CBO', sortable: true},
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
        item: null,
        model: {
            ocupacao: null,
            ocupacoes: [],
        },
    }),
    methods: {
        open(item) {
            this.resetForm()

            this.item = item

            this.model.ocupacoes = this.clone(item.ocupacoes)

            this.$refs.RkmModal.show()
        },
        store() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    if (this.model.ocupacoes.find(ocupacao => ocupacao.id === this.model.ocupacao.id)) {
                        this.showValidationNotification('O CBO já foi incluído.')
                        return
                    }

                    this.model.ocupacoes.push({
                        id: this.model.ocupacao.id,
                        codigo: this.model.ocupacao.codigo,
                        nome: this.model.ocupacao.nome,
                    })

                    this.resetForm()
                })
        },
        include() {
            this.store()
        },
        destroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir o CBO?', async () => {
                this.model.ocupacoes.splice(index, 1)
            })
        },
        save() {
            this.item.ocupacoes = this.model.ocupacoes

            this.$refs.RkmModal.hide()
        },
        clean() {
            this.resetForm()
        },
        resetForm() {
            this.model.ocupacao = null

            this.$nextTick().then(() => this.$refs.RkmForm.resetValidator())
        },
    },
    mixins: [error, object, repository, stringCase],
}
</script>